import { render, staticRenderFns } from "./teamPerformanceChart.vue?vue&type=template&id=f7b4b2d6&scoped=true&lang=html&"
import script from "./teamPerformanceChart.vue?vue&type=script&lang=ts&"
export * from "./teamPerformanceChart.vue?vue&type=script&lang=ts&"
import style0 from "./teamPerformanceChart.vue?vue&type=style&index=0&id=f7b4b2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b4b2d6",
  null
  
)

export default component.exports